import React, { FC } from 'react'
import { IShop } from '../../types'
import css from './Shop.module.scss'
import cx from 'classnames'

const Shop: FC<{ shop: IShop; border?: boolean; single?: boolean }> = ({
  shop,
  border,
  single,
}) => {
  if (!shop) {
    return null
  }
  const showContactsBlock = shop.phone || shop.mail || shop.address
  const phones = shop.phone ? shop.phone.split(', ') : null

  return (
    <li className={cx(css.wrapper, border && css.border, single && css.single)}>
      <p className={css.name}>{shop.name}</p>

      {showContactsBlock && (
        <address className={css.contacts}>
          {shop.address && <p className={css.contacts_item}>{shop.address}</p>}

          {phones?.length > 0 && (
            <p className={css.contacts_item}>
              {phones.map((phone, index) => (
                <a
                  key={`shop-${shop.code}-phone-${index}`}
                  href={`tel:${phone}`}
                >
                  {phone}
                  {index !== phones.length - 1 && ', '}
                </a>
              ))}
            </p>
          )}

          {shop.mail && (
            <p className={css.contacts_item}>
              <a href={`mailto:${shop.mail}`}>{shop.mail}</a>
            </p>
          )}
        </address>
      )}

      {shop.site && (
        <p className={css.site}>
          <a href={shop.site} target="_blank" rel="noreferrer">
            {shop.site}
          </a>
        </p>
      )}
    </li>
  )
}

export default Shop
